import { Coordinates } from "@gsx/common";

export enum EventTopic {
    Communication = "Communication",
    Exploration = "Exploration",
    Financial = "Financial",
    General = "Industry Wide",
    GroundOperator = "Ground Operator",
    Mechanisms = "Mechanisms",
    Military = "Military",
    Processing = "Processing",
    Regulatory = "Regulatory",
    SmallSatellite = "Small Satellite",
}

export enum EventType {
    Conferences = "Conferences",
    IndustryDay = "Industry Day",
    MediaDay = "Media Day",
    Networking = "Networking",
    CorporateMilestone = "Corporate Milestone",
    Training = "Training",
    Webinar = "Webinar",
    Virtual = "Virtual",
    Milestone = "Interesting Space Events & Industry Milestones",
    SocialEvent = "Social Event",
    Podcast = "Podcast",
    Forum = "Forum",
    TechnologyExposition = "Technology Exposition",
}

export interface Deadline {
    date: Date;
    title: string;
}

export interface Conference {
    city?: string;
    conferenceid: string;
    country?: string;
    deadlines?: Deadline[];
    details?: string;
    endDate?: Date;
    logo?: string;
    name: string;
    organizingOrganizations?: string[];
    startDate: Date;
    state?: string;
    topics?: EventTopic[];
    types?: EventType[];
    userId: string;
    coordinates?: Coordinates | null;
    updatedAt?: Date;
    url?: string;
}
